import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { GrSkeletonLoaderShape } from './skeleton-loader.types';

@Component({
  selector: 'gr-skeleton-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: contents;' },
  template: `
    <span
      [class]="classList()"
      [style.width]="width() || null"
      [style.height]="height() || null"
      [style.borderRadius]="radius() || null"
      aria-hidden="true"
    ></span>
  `,
})
export class GrSkeletonLoaderComponent {
  readonly shape = input<GrSkeletonLoaderShape>('rect');
  readonly width = input<string>('');
  readonly height = input<string>('');
  readonly radius = input<string>('');
  readonly styleClass = input<string>('');

  protected readonly classList = computed<string>(() => {
    const s = this.shape();
    const mod =
      s === 'text'
        ? ' gr-skeleton-loader--text'
        : s === 'circle'
          ? ' gr-skeleton-loader--circle'
          : s === 'pill'
            ? ' gr-skeleton-loader--pill'
            : '';
    const extra = this.styleClass() ? ' ' + this.styleClass() : '';
    return 'gr-skeleton-loader' + mod + extra;
  });
}
